export const METER_FIELD_GROUPS = [
    { label: 'Voltage (Phase-Neutral)', aliases: ['voltage', 'v phase', 'phase voltage', 'voltage phases', 'voltage breakdown'], groupKey: 'vpn', subKeys: ['V_R', 'V_Y', 'V_B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Voltage (Phase-Phase)', aliases: ['line voltage', 'voltage line', 'vll', 'phase-phase voltage'], groupKey: 'vpp', subKeys: ['V_RY', 'V_YB', 'V_BR'], subLabels: ['RY', 'YB', 'BR'] },
    { label: 'Current', aliases: ['current', 'current phases', 'phase current', 'current breakdown'], groupKey: 'iavg', subKeys: ['Cu_R', 'Cu_Y', 'Cu_B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Power (kW)', aliases: ['power', 'kw', 'active power', 'power breakdown', 'demand', 'load'], groupKey: 'KW', subKeys: ['R', 'Y', 'B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Apparent Power (kVA)', aliases: ['kva', 'apparent power'], groupKey: 'KVA', subKeys: ['R', 'Y', 'B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Power Factor', aliases: ['power factor', 'pf', 'power factor breakdown'], groupKey: 'PF', subKeys: ['R', 'Y', 'B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Voltage THD', aliases: ['voltage thd', 'vthd', 'v harmonics'], groupKey: 'VTHD', subKeys: ['VHar_R', 'VHar_Y', 'VHar_B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Current THD', aliases: ['current thd', 'ithd', 'i harmonics'], groupKey: 'ITHD', subKeys: ['CuHar_R', 'CuHar_Y', 'CuHar_B'], subLabels: ['R', 'Y', 'B'] },
    { label: 'Energy (kWh)', aliases: ['energy', 'total energy', 'total kwh', 'kwh', 'consumption', 'hourly consumption', 'energy cost', 'energy breakdown'], groupKey: 'kWh', subKeys: ['R', 'Y', 'B'], subLabels: ['R', 'Y', 'B'] },
];

const normalize = (s) => (s || '').toLowerCase().trim();
const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function matchMeterFieldGroup(title) {
    const t = normalize(title);
    if (!t) return null;
    let best = null;
    METER_FIELD_GROUPS.forEach((group) => {
        [group.label, ...group.aliases].forEach((raw) => {
            const candidate = normalize(raw);
            if (!candidate) return;
            const re = new RegExp(`\\b${escapeRegex(candidate)}\\b`, 'i');
            if (re.test(t) && (!best || candidate.length > best.len)) {
                best = { group, len: candidate.length };
            }
        });
    });
    return best ? best.group : null;
}
